var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8F1F4",
    fillRule: "evenodd",
    d: "m13.914 12 4.293-4.293a.999.999 0 1 0-1.414-1.414L12.5 10.586 8.207 6.293a.999.999 0 1 0-1.414 1.414L11.086 12l-4.293 4.293a.999.999 0 1 0 1.414 1.414l4.293-4.293 4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L13.914 12Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 13,
    height: 13,
    x: 6,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m13.914 12 4.293-4.293a.999.999 0 1 0-1.414-1.414L12.5 10.586 8.207 6.293a.999.999 0 1 0-1.414 1.414L11.086 12l-4.293 4.293a.999.999 0 1 0 1.414 1.414l4.293-4.293 4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L13.914 12Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8F1F4",
    d: "M.5 0h24v24H.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.f36ed068e7cefe6482e8a57dbd235011.svg";
export { ForwardRef as ReactComponent };